import { PlusOutlined } from '@ant-design/icons';
import { useMutation } from '@apollo/client';
import { Button, Card, Form } from 'antd';
import { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../../../../../AppContext';
import {
  EXPORT_TYPES,
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
  ROUTES,
  TABLE_FILTER_KEYS,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import ExportDateRangeModal from '../../../../../components/ExportDateRangeModal';
import Portal from '../../../../../components/Portal';
import ResetFilterButton from '../../../../../components/ResetFilterButton';
import UserPayoutLinksTable from '../components/UserPayoutLinksTable';
import { REQUEST_PAYMENT_LINKS_EXPORT } from '../graphql/Mutations';

const PaymentLinks = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const history = useHistory();
  const [form] = Form.useForm();
  const [exportFilter, setExportFilter] = useState({});
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [requestPaymentLinksExport] = useMutation(
    REQUEST_PAYMENT_LINKS_EXPORT,
    {
      onError: () => {},
    },
  );

  const handleExport = async (values) => {
    setIsExportLoading(true);
    const res = await requestPaymentLinksExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.PAYMENT_LINKS,
        },
        filter: {
          search: exportFilter?.search,
          dateRange: {
            from: values?.date?.[0]?.startOf('day'),
            to: values?.date?.[1]?.endOf('day'),
          },
          expiredAtDate: {
            from: exportFilter?.expiredAt?.from?.$d,
            to: exportFilter?.expiredAt?.to?.$d,
          },
          ...(exportFilter?.status?.length > 0 && {
            status: exportFilter?.status,
          }),
        },
      },
    });
    if (res?.data) {
      setIsModalOpen(false);
      form?.resetFields();
    }
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.PAYMENT_LINKS}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.OFFERS_PAYOUT_LINK,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() =>
              history?.push(
                `${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}/add`,
              )
            }
          >
            Create User Payout Link
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.OFFERS_PAYOUT_LINK,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() =>
              history?.push(
                `${ROUTES?.PAYMENTS}${ROUTES?.USER_PAYOUT_LINKS}/add`,
              )
            }
          >
            Create User Payout Link
          </Button>
        )}
      </Portal>
      <ResetFilterButton tableKey={TABLE_FILTER_KEYS.PAYMENTS_PAYOUT_LINKS} />
      <ExportDateRangeModal
        form={form}
        onFinish={handleExport}
        loadings={isExportLoading}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
      <Card className="full-height-without-nav">
        <UserPayoutLinksTable
          exportFilter={exportFilter}
          setExportFilter={setExportFilter}
        />
      </Card>
    </>
  );
};

export default PaymentLinks;
